import { render, staticRenderFns } from "./Hours.vue?vue&type=template&id=b2554bd0&scoped=true&"
import script from "./Hours.vue?vue&type=script&lang=js&"
export * from "./Hours.vue?vue&type=script&lang=js&"
import style0 from "./Hours.vue?vue&type=style&index=0&id=b2554bd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2554bd0",
  null
  
)

export default component.exports